module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-79.6742706.woff2";